<template>
    <CRow>
        <CCol>
            <CCard v-if="entity">
                <CCardHeader>
                    <strong>{{ entity.name }}</strong>
                </CCardHeader>
                <CCardBody>
                    <ConciergeTabLinks />
                    <ConciergeUpsertForm
                        class="mt-4 ml-2 ml-2"
                        :entity.sync="entity"
                        @success="$router.push(`/concierges`)"
                        @deleted="$router.push(`/concierges`)"
                    />
                </CCardBody>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import ConciergeTabLinks from '@/components/concierges/ConciergeTabLinks';
    import ConciergeUpsertForm from '@/components/concierges/ConciergeUpsertForm';

    export default {
        name: 'ConciergeEdit',

        components: {
            ConciergeTabLinks,
            ConciergeUpsertForm,
        },

        data() {
            return {
                entity: undefined,
            };
        },

        async created() {
            await this.fetch();
        },

        methods: {
            async fetch() {
                const { id } = this.$route.params;
                this.entity = (await this.axios.get(`/concierges/${id}`)).data;
            },
        },
    };
</script>
